import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  Renderer2
} from '@angular/core';
import { SwitchingProfileDisplay } from './models/switching-profile.models';

@Component({
  selector: 'idp-switching-profile',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './switching-profile.component.html',
  styleUrls: ['./switching-profile.component.scss']
})
export class SwitchingProfileComponent {
  renderer = inject(Renderer2);

  @Input() content: SwitchingProfileDisplay = {} as SwitchingProfileDisplay;
  @Input() flyoutToggle = false;
  @Output() flyoutToggleChange = new EventEmitter<boolean>(false);
  @Output() analyticsEvent = new EventEmitter<Event>();

  openProfileSelectorModal(event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      this.analyticsEvent.emit(event);
    }

    this.flyoutToggleChange.emit(!this.flyoutToggle);
  }
}
